import React, { useRef, useEffect, useState } from "react";

import { HandleSetRealTimeDB } from '../../DBServices/realTimeDBService';
import ChatBox from './ChatBox';
import CustomerList from "./CustomerList";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import sound from "./assets/notificationTone.mp3";

const Agent = () => {

  const [ mainState, setMainState ] = useState({
    customers: [],
    selectedCustomer: '',
    chat: [],
    chatIsLoading: true,
    customerIsLoading: true,
    modal: false,
    chatData: {}
  });

  const containerRef = useRef(null);
  const message = useRef();

  useEffect(() => {
    
    const fetchChatData = (selectedCustomer) => {
      const starCountRef = HandleSetRealTimeDB.ref(HandleSetRealTimeDB.database, `messages`);
      return HandleSetRealTimeDB.onValue(starCountRef, (snapshot) => {
        if(snapshot.exists()) {
          let snapshotData = snapshot.val()
          console.log(snapshotData)
          selectedCustomer = selectedCustomer || Object.keys(snapshotData)[0];
          setMainState((prev) => ({...prev, chatData: snapshotData, selectedCustomer}));
          return;
        } else {
          setMainState((prev) => ({...prev,
            customers: [{customer:'No Message To Show!'}],
            chat: [],
            customerIsLoading: false,
            chatIsLoading: false
          }));
          return;
        }
      });
    }
    let selectedCustomer = mainState.selectedCustomer;
    fetchChatData(selectedCustomer);

  }, [mainState.selectedCustomer, HandleSetRealTimeDB.database]);

  console.log(mainState.chatData)

  useEffect(() => {
    
    const fetchChat = (snapshot) => {
      if (snapshot && Object.keys(snapshot).length) {
      
        let customer_list = [];
        let chats = [];
        let selectedCustomer = mainState.selectedCustomer;
        Object.entries(snapshot).forEach(([cust, custChat]) => {
          if (cust === selectedCustomer) {
            customer_list = [...customer_list, {customer: cust}];
            Object.values(custChat).forEach((chatObj) => {
              chats = [...chats, chatObj];
            });
          } else {
            let i = 0;
            let j = 0;
            const customerChats = Object.values(custChat);
            console.log(customerChats)
            for (const chatObj of customerChats) {          
              j+=1;
              if (chatObj.new) {
                i += 1;
                customer_list = [...customer_list, {customer: cust, new: 'new'}];
                new Audio(sound).play()
                break;
              }
              if (j === customerChats.length && i === 0) {
                customer_list = [...customer_list, {customer: cust}];
              }
            }
          }
        });
        
        setMainState((prev) => ({
          ...prev,
          chat: chats,
          customers: customer_list,
          customerIsLoading: false, 
          chatIsLoading: false,
          containerRef,
          tabIndex: -1
        }));
      }
    }
    let snapshot = mainState.chatData;
    console.log(snapshot)
    fetchChat(snapshot)
  }, [mainState.selectedCustomer, mainState.chatData])
  


  const handleSubmit = async (event) => {
    event.preventDefault();
    let mes = message.current.value;
    
    const selectedCustomer = mainState.selectedCustomer;
    
    let textMessage = {
      message: mes,
    };

    if (selectedCustomer) {
      await HandleSetRealTimeDB.push(HandleSetRealTimeDB.ref(HandleSetRealTimeDB.database, 'messages/' + selectedCustomer), textMessage)
      .then(() => {
        // Data saved successfully!
      })
      .catch((error) => {
        // The write failed...
        alert("Unable to send message, please resend.");
      });
      message.current.value = '';
      return;
    } else {
      message.current.value = '';
      return;
    }
  };

  const selectCustomer = (selectedCustomer) => {
    console.log(selectedCustomer)
    setMainState((prev) => ({
      ...prev,
      selectedCustomer
    })) 
    const dbRef = HandleSetRealTimeDB.ref(HandleSetRealTimeDB.getDatabase());
    HandleSetRealTimeDB.get(HandleSetRealTimeDB.child(dbRef, `messages/${selectedCustomer}`))
    .then((snapshot) => {
      if (snapshot.exists()) {
        snapshot.forEach((childSnapshot) => {
          if (childSnapshot.val().new) {
            HandleSetRealTimeDB.update(HandleSetRealTimeDB
            .ref(HandleSetRealTimeDB.database, `messages/${selectedCustomer}/${childSnapshot.key}`), {new: null})
            .then()
            .catch((error) => {
              alert(error.message.replace('Firebase: ', ''));
            })
          }         
        })
      }
    }).catch((error) => {
      alert(error.message.replace('Firebase: ', ''));
    })         
  };


  const deleteAllChats = () => {
    if (mainState.chat.length) {
      return HandleSetRealTimeDB.set(HandleSetRealTimeDB
        .ref(HandleSetRealTimeDB.database, 'messages'), null)
      .then(() => {
        // Data saved successfully!
      })
      .catch((error) => {
        // The write failed...
        alert("Unable to delete message, please try again later.");
        return;
      });      
    } else {
      return;
    }
  }


  const toggle = () => {
    setMainState((prev) => ({...prev,
      modal: !mainState.modal
    }));
  }

    return (
      <div className="body-customer-support">                
        <div className="container-fluid">
          <div>
            <Modal isOpen={mainState.modal} toggle={toggle}>
              <ModalHeader toggle={toggle}>Warning!</ModalHeader>
              <ModalBody>
                Are you sure you want to delete all chats? This cannot be undone!
              </ModalBody>
              <ModalFooter>
                <Button color="danger" onClick={deleteAllChats}>Yes! Delete all chats</Button>{' '}
                <Button color="success" onClick={toggle}>No, go back</Button>
              </ModalFooter>
            </Modal>
          </div>        
          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-8 h-100pr border rounded">
              <div className="row">
                <div
                  className="col-lg-4 col-xs-12 bg-light"
                  style={{ height: 658 }}
                >
                  <div className="row p-3">
                    <h2>Customer List</h2>
                  </div>
                  <div
                    className="row ml-0 mr-0 h-75 bg-white border rounded"
                    style={{ height: "100%", overflow: "auto" }}
                  >
                    <CustomerList
                      {...mainState}
                      selectCustomer={selectCustomer}
                    />
                  </div>
                </div>
                <div
                  className="col-lg-8 col-xs-12 bg-light"
                  style={{ height: 658 }}
                >
                  <div className="row p-3 bg-white">
                    <h2 className="col-lg-8 col-md-8 col-sm-8 col-xs-12">Messages</h2>
                    <span className="col-lg-4 col-md-4 col-sm-4 col-xs-12 text-right">
                      <Button color="danger" onClick={toggle}>
                        Clear All {" "}
                        <i className="header-icon lnr-cross icon-gradient bg-dark">
                          {" "}
                        </i>
                      </Button>                
                    </span>
                  </div>
                  <hr />
                  <div
                    className="row pt-5 bg-white"
                    style={{ height: 530, overflow: "auto" }}
                  >
                    <ChatBox {...mainState} />
                  </div>
                  <div
                    className="row bg-light"
                    style={{ bottom: 0, width: "100%" }}
                  >
                    <form
                      className="row m-0 p-0 w-100"
                      onSubmit={handleSubmit}
                    >
                      <div className="col-9 m-0 p-1">
                        <input
                          id="text"
                          className="mw-100 border rounded form-control"
                          type="text"
                          name="text"
                          ref={message}
                          placeholder="Type a message..."
                        />
                      </div>
                      <div className="col-3 m-0 p-1">
                        <button
                          className="btn btn-outline-secondary rounded border w-100"
                          title="Send"
                          style={{ paddingRight: 16 }}
                        >
                          Send
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  
}

export default React.memo(Agent);
